import { MomentInput } from "moment";
import { useTheme } from "PFApp/theme_context_provider/theme_context_provider_context";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { DEFAULT_DATE_FORMAT, utc } from "PFCore/helpers/date";

type MisalignmentHeaderProps = {
  start: string;
  end: string;
};

export const MisalignmentHeader = ({ start, end }: MisalignmentHeaderProps) => {
  const { themeVars } = useTheme();
  const isOneDay = start === end;
  const formatDate = (date: MomentInput) => utc(date).format(DEFAULT_DATE_FORMAT);

  return (
    <>
      <Icon name="calendar-delete" fill={themeVars["paletteOrange3"]} />
      <Typography variant="labelBold">
        {isOneDay ? formatDate(start) : `${formatDate(start)} - ${formatDate(end)}`}
      </Typography>
    </>
  );
};
